import XEUtils from "xe-utils";
import httpManager from "../../util/common";
import EntityTitle from '@/entity/components/EntityTitle'
import {entityOaid, reportYear} from "../../util/util";

let license_detail = {
  components: {EntityTitle},
  // props: ['oaid'],
  data: () => {
    return {
      data: [],
      oaid: null,
      start_date: null,
      end_date: null,
      pollution_permit_category: '全部',
      pollution_permit_category_options: null,
      industry_code: [],
      industry_code_options: [],
      // location_county: null,
      atmospheric_focus_areas: null,
      phosphorus_control_area: null,
      nitrogen_control_area: null,
      heavy_metal_area: null,
      need_be_corrected: null,
      industrial_park: null,
      loading: false,
      tableColumn: [
        {title: 'i18n.pollution.original_permit_id', field: 'original_permit_id', width: 130},
        {title: 'i18n.pollution.current_permit_id', field: 'current_permit_id', width: 120},
        {title: 'i18n.pollution.emission_unit_name', field: 'company_name', width: 200},
        {title: 'i18n.pollution.location', field: 'location_county'},
        {title: 'i18n.pollution.industry', field: 'industry'},
        {title: 'i18n.pollution.first_issue_date', field: 'issue_date', width: 120},
        {title: 'i18n.pollution.current_license_validity_period', field: 'valid_period'},
        {title: 'i18n.pollution.main_pollutants', field: 'main_pollutant_categories'},
        {title: 'i18n.pollution.pollutants_permit_category', field: 'pollution_permit_category', width: 80},
        {title: 'i18n.pollution.key_atmospheric_control_area', field: 'atmospheric_focus_areas', width: 60},
        {title: 'i18n.pollution.total_phosphorus_control_area', field: 'phosphorus_control_area', width: 60},
        {title: 'i18n.pollution.total_nitrogen_control_area', field: 'nitrogen_control_area', width: 60},
        {title: 'i18n.pollution.implementation_area_of_special_emission_limits_for_heavy_metal_pollution', field: 'heavy_metal_area', width: 80},
        {title: 'i18n.pollution.need_to_be_rectified', field: 'need_be_corrected', width: 60},
        {title: 'i18n.pollution.located_in_the_industrial_park', field: 'industrial_park', width: 60}
      ],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
        align: 'center',
        pageSizes: [10, 20, 50, 100, 200, 500],
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true,
        pagerCount: 3
      }
    }
  },
  methods: {
    industryCodeOnChange (value, selectedOptions) {
      this.industry_code = value
    },
    industryCodeFilter (inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    formatBoolVal (val) {
      if (val === true) {
        return '是'
      }
      if (val === false) {
        return '否'
      }
    },
    formatPollutionPermitCategory (val) {
      if (val === true) {
        return '重点管理'
      }
      if (val === false) {
        return '简化管理'
      }
    },
    searchLicenseDetailKeyUp (e) {
      if (e.$event.key === 'Enter') {
        this.getLicenseDetailData()
      }
    },
    clearData () {
      this.data = []
      this.page.pageSize = 20
      this.page.currentPage = 1
      this.page.total = 0
      this.start_date = null
      this.end_date = null
      this.pollution_permit_category = '全部'
      // this.industry = null
      // this.location_county = null
      this.atmospheric_focus_areas = null
      this.phosphorus_control_area = null
      this.nitrogen_control_area = null
      this.heavy_metal_area = null
      this.need_be_corrected = null
      this.industrial_park = null
    },
    searchLicenseDetailData () {
      this.getLicenseDetailData()
    },
    pageChange ({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getLicenseDetailData()
    },
    changeOaid () {
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid = result
        self.getLicenseDetailData()
      })
    },
    getLicenseDetailData () {
      let self = this
      if (self.oaid) {
        self.data = []
        self.loading = true
        let params = new Map()
        params.set('oaid', self.oaid)
        if (self.industry_code.length > 0) {
          params.set('industry_code', self.industry_code.slice(-1)[0])
        }
        if (self.pollution_permit_category !== '全部') {
          params.set('pollution_permit_category', self.pollution_permit_category)
        }
        let paramKeys = [
          'start_date', 'end_date', 'atmospheric_focus_areas', 'phosphorus_control_area',
          'nitrogen_control_area', 'heavy_metal_area', 'need_be_corrected', 'industrial_park']
        paramKeys.forEach(function (value, index, array) {
          if (self[value]) {
            params.set(value, self[value])
          }
        })
        if (params.length === 0) {
          return
        }
        params.set('pagenum', self.page.currentPage)
        params.set('pagesize', self.page.pageSize)
        httpManager('pollution_entity_license_info', params, null, null, null)
          .then(response => {
            self.data = []
            if (response.data.data.length > 0) {
              response.data.data.forEach(function (value, index, array) {
                let item = value
                paramKeys.forEach(function (key, i, a) {
                  item[key] = self.formatBoolVal(item[key])
                })
                item['pollution_permit_category'] = self.formatPollutionPermitCategory(item['pollution_permit_category'])
                item['valid_period'] = item['effect_date'] + '～' + item['expire_date']
                item['location_county'] = item['province'] + '-' + item['district'] + '-' + item['county']
              })
              self.data = response.data.data
            }
            let page = response.data.page
            self.page.total = page.total
            self.loading = false
          })
          .catch(error => {
            console.log(error)
            self.loading = false
          })
      }
    }
  },
  mounted () {
    reportYear.esg_report_month().then(result => {
      this.industry_code_options = result.industry_code
    })
    this.changeOaid()
    this.news_type_options()
  },
  computed:{
    news_type_options() {
      this.pollution_permit_category_options = [
        {label: this.$t('pollution.all'), value: '全部'},
        {label: this.$t('pollution.advanced_management'), value: true},
        {label: this.$t('pollution.simplified_management'), value: false}
      ]
    },
  },
  watch: {
    start_date: function () {
      this.page.currentPage = 1
      this.getLicenseDetailData()
    },
    end_date: function () {
      this.page.currentPage = 1
      this.getLicenseDetailData()
    },
    pollution_permit_category: function () {
      if (this.pollution_permit_category == null) {
        this.pollution_permit_category = '全部'
      }
      this.page.currentPage = 1
      this.getLicenseDetailData()
    },
    atmospheric_focus_areas: function () {
      this.page.currentPage = 1
      this.getLicenseDetailData()
    },
    phosphorus_control_area: function () {
      this.page.currentPage = 1
      this.getLicenseDetailData()
    },
    nitrogen_control_area: function () {
      this.page.currentPage = 1
      this.getLicenseDetailData()
    },
    heavy_metal_area: function () {
      this.page.currentPage = 1
      this.getLicenseDetailData()
    },
    need_be_corrected: function () {
      this.page.currentPage = 1
      this.getLicenseDetailData()
    },
    industrial_park: function () {
      this.page.currentPage = 1
      this.getLicenseDetailData()
    },
    industry_code: function () {
      this.page.currentPage = 1
      this.getLicenseDetailData()
    }
  }
}
export default license_detail



// WEBPACK FOOTER //
// ./src/pollution/js/license_detail.js